document.addEventListener('DOMContentLoaded', function() {
  // 处理所有视频列表
  const videoListSections = document.querySelectorAll('.mt-video-list');
  
  videoListSections.forEach(section => {
    const sectionId = section.dataset.sectionId;
    const videoCards = section.querySelectorAll('.mt-video-list-card');
    
    videoCards.forEach(card => {
      const video = card.querySelector('.mt-video');
      const youtubeWrapper = card.querySelector('.mt-youtube-video-wrapper');
      const poster = card.querySelector('.mt-poster');
      const iconBefore = card.querySelector('.mt-media-icon-before');
      const iconAfter = card.querySelector('.mt-media-icon-after');
      
      // 处理上传的视频
      if (video) {
        let isPlaying = false;
        
        card.addEventListener('click', function() {
          if (!isPlaying) {
            video.play();
            isPlaying = true;
            if (poster) poster.style.display = 'none';
            if (iconBefore) iconBefore.style.display = 'none';
            if (iconAfter) iconAfter.style.display = 'block';
          } else {
            video.pause();
            isPlaying = false;
            if (poster) poster.style.display = 'block';
            if (iconBefore) iconBefore.style.display = 'block';
            if (iconAfter) iconAfter.style.display = 'none';
          }
        });
        
        video.addEventListener('ended', function() {
          isPlaying = false;
          if (poster) poster.style.display = 'block';
          if (iconBefore) iconBefore.style.display = 'block';
          if (iconAfter) iconAfter.style.display = 'none';
        });
      }
      
      // YouTube 视频直接显示，不需要点击播放逻辑
      // YouTube iframe 已经直接显示，用户可以在 iframe 中直接控制播放
    });
    
    // 处理导航按钮
    const leftBtn = document.getElementById(`mt-video-list-left-btn-${sectionId}`);
    const rightBtn = document.getElementById(`mt-video-list-right-btn-${sectionId}`);
    const swiperWrapper = document.getElementById(`mt-video-list-swiper-wrapper-${sectionId}`);
    
    if (leftBtn && rightBtn && swiperWrapper) {
      // 计算滚动距离：一屏的宽度
      function calculateScrollAmount() {
        // 直接使用容器的可见宽度作为滚动距离（一屏的宽度）
        return swiperWrapper.clientWidth;
      }
      
      // 使用容器的当前滚动位置，而不是维护单独的变量
      leftBtn.addEventListener('click', function() {
        const scrollAmount = calculateScrollAmount();
        const currentScroll = swiperWrapper.scrollLeft;
        const newScroll = Math.max(0, currentScroll - scrollAmount);
        swiperWrapper.scrollTo({
          left: newScroll,
          behavior: 'smooth'
        });
      });
      
      rightBtn.addEventListener('click', function() {
        const scrollAmount = calculateScrollAmount();
        const currentScroll = swiperWrapper.scrollLeft;
        const maxScroll = swiperWrapper.scrollWidth - swiperWrapper.clientWidth;
        const newScroll = Math.min(maxScroll, currentScroll + scrollAmount);
        swiperWrapper.scrollTo({
          left: newScroll,
          behavior: 'smooth'
        });
      });
    }
  });
});

